import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'about-company',
    templateUrl: './about-company.component.html',
    styleUrls: ['./about-company.component.less'],
    standalone: false
})
export class AboutCompanyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
